module.exports = __webpack_public_path__ + "29c587e6cf1705132b046c5f2bd321df.woff";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/LeagueGothic/leaguegothic-regular-webfont.woff
// module id = 433
// module chunks = 0